<script lang="ts" setup>
import { onMounted } from 'vue'
import useOverlay from '@/legacy/ts/useOverlay'

const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
	title: {
		type: String,
		default: '',
	},
	isShowBackIcon: {
		type: Boolean,
		default: false,
	},
	lockScroll: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits(['update:modelValue'])
function updateModelValue(value: boolean) {
	emit('update:modelValue', value)
}
const { isShow, freezeBodyScroll } = useOverlay(props, updateModelValue)

onMounted(() => {
	if (props.lockScroll) {
		freezeBodyScroll()
	}
})
</script>

<template>
	<Transition name="bs-side__animation">
		<div class="bs-side" v-show="isShow">
			<div class="bs-side__overlay" @click="isShow = false"></div>
			<div class="bs-side__panel">
				<div class="bs-side__panel__header">
					<div class="bs-side__panel__header--left" @click="isShow = false">
						<span
							v-if="isShowBackIcon"
							class="bs-side__icon bs-icon-side-drawer-back"
						></span>
						<span v-else class="bs-side__icon bs-icon-side-drawer-close"></span>
					</div>
					<span class="bs-side__panel__header__title">
						{{ title }}
					</span>
					<div class="bs-side__panel__header__trailing">
						<slot name="title-trailing" />
					</div>
				</div>
				<div class="bs-side__panel__main">
					<slot />
				</div>
			</div>
		</div>
	</Transition>
</template>
